export enum Orientation {
    Horizontal = "Horizontal",
    Vertical = "Vertical"
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/enums/orientation.ts